import styled from 'styled-components';

export const CheckBoxLabel = styled.label(
  props => `
      display: block;
      position: relative;
      cursor: pointer;
      user-select: none;
      display: flex;
      align-items: center;
    `,
);

export const Checkmark = styled.span(
  props => `
      position: relative;
      height: 15px;
      width: 15px;
      background: white;
      border: solid 2px #B0B0B0;
      border-radius:2px;
      &::after {
        display: none;
        content: '';
        left: 5px;
        top: 2px;
        position: absolute;
        width: 5px;
        height: 9px;
        border: solid white;
        border-width: 0 1.5px 1.5px 0;
        transform: rotate(45deg);
      }
    `,
);

export const CheckBox = styled.input(
  props => `
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
  
      
      &:checked ~ ${Checkmark} {
        background:#2276e3;
        border: none;
        &::after {
          display: block;
        }
      }
    `,
);

export const CheckboxIcon = styled.span(
  props => `
    display: flex;
    background-color:#f3f6f8;
    border-radius:0.3rem;
    padding:${props.theme.spacing.small};
    margin-left:${props.theme.spacing.base};
    min-width: 2.5rem;
    height: 2.5rem;
  `,
);

export const CheckboxText = styled.span(
  props => `
  
    padding-left: 1rem;
    font-size:1.4rem;
    max-width: 22.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &.active{
      color:#2276e3;
      font-size:${props.theme.font.custom(14)};
    }
  
  `,
);
